import { render } from "./AddFiliereNiveauMatiere.vue?vue&type=template&id=0e415fe2&ts=true"
import script from "./AddFiliereNiveauMatiere.vue?vue&type=script&lang=ts"
export * from "./AddFiliereNiveauMatiere.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__